import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3 3.80425C3 3.01881 3.86395 2.53997 4.53 2.95625L9.6432 6.152C10.2699 6.54367 10.2699 7.45633 9.6432 7.848L4.53 11.0438C3.86395 11.46 3 10.9812 3 10.1958V3.80425Z" })
});
export default SvgPlayFilled;
